import { Link } from "react-router-dom";
import { ExportPdfButton } from "@/components/ExportPdfButton";
import { LogoutButton } from "@/components/LogoutButton";
import type { FolioPrincipal } from "@/lib/types";

export function DashboardSidebar({ principal }: { principal: FolioPrincipal }) {
  return (
    <aside className="flex flex-col gap-6 border-b border-slate-200 bg-white px-6 py-6 lg:h-screen lg:w-72 lg:border-b-0 lg:border-r lg:sticky lg:top-0">
      <Link
        to="/"
        className="group inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition hover:text-slate-900"
      >
        <span className="grid h-9 w-9 place-items-center rounded-lg bg-slate-900 text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4 text-indigo-300"
            aria-hidden
          >
            <path d="M3 21h18" />
            <path d="M5 21V7l7-4 7 4v14" />
            <path d="M9 9h1" />
            <path d="M9 13h1" />
            <path d="M9 17h1" />
            <path d="M14 9h1" />
            <path d="M14 13h1" />
            <path d="M14 17h1" />
          </svg>
        </span>
        <span>
          <span className="block text-xs uppercase tracking-wider text-slate-400 group-hover:text-slate-500">
            RPPC Jalisco
          </span>
          <span className="text-sm">Volver al inicio</span>
        </span>
      </Link>

      <div className="rounded-2xl bg-slate-900 p-5 text-white">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-400">
          Folio
        </p>
        <p className="mt-1 font-mono text-2xl font-semibold tracking-tight">
          {principal.folioRegistral}
        </p>
        <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
          <div>
            <p className="text-slate-400">Núm. cuenta</p>
            <p className="mt-0.5 font-mono text-slate-100">
              {principal.numeroCuenta ?? "—"}
            </p>
          </div>
          <div>
            <p className="text-slate-400">Catastral</p>
            <p className="mt-0.5 font-mono text-slate-100">
              {principal.claveCatastral ?? "—"}
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
          Acciones
        </p>
        <ExportPdfButton folioId={principal.folioRegistral} />
        <Link
          to="/"
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden
          >
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
          </svg>
          Nueva consulta
        </Link>
        <LogoutButton />
      </div>

    </aside>
  );
}
